module.exports = __webpack_public_path__ + "static/media/Sprint_DataSecurityPrivacy.fdff2a73.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/SHS-SPRINT/Sprint_DataSecurityPrivacy.jpg
// module id = 3761
// module chunks = 0